import { useRef } from "react";
import TitleCard from "@/components/feature/TitleCard";
import { getRelatedTitles } from "@/hooks/useCatalog";
import type { Title } from "@/mocks/titles";

export default function RelatedRail({ item }: { item: Title }) {
  const related = getRelatedTitles(item, 8);
  const scrollerRef = useRef<HTMLDivElement>(null);

  const scrollBy = (direction: 1 | -1) => {
    scrollerRef.current?.scrollBy({ left: direction * 400, behavior: "smooth" });
  };

  if (related.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="mx-auto max-w-[1440px]">
        <div className="mb-5 flex items-end justify-between gap-4">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs tracking-[0.18em] text-accent-600">
              <span className="inline-block h-3 w-0.5 bg-accent-500"></span>
              相关推荐
            </p>
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">看过这部，也许你会喜欢</h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollBy(-1)}
              aria-label="向左滚动推荐"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-arrow-left-s-line text-lg" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              onClick={() => scrollBy(1)}
              aria-label="向右滚动推荐"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div ref={scrollerRef} className="no-scrollbar flex gap-3 overflow-x-auto pb-2 md:gap-5">
          {related.map((entry) => (
            <div key={entry.id} className="w-[150px] shrink-0 md:w-[190px]">
              <TitleCard item={entry} variant="compact" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}